import { Icon } from '@chakra-ui/react';
import {
  MdDashboard,
  MdHome,
  MdPeople,
  MdRadar,
  MdAutoGraph,
  MdSettings,
} from 'react-icons/md';

// Auth Imports
import ForgotPasswordCentered from 'views/auth/forgotPassword/ForgotPasswordCentered';
import ForgotPasswordDefault from 'views/auth/forgotPassword/ForgotPasswordDefault';
import LockCentered from 'views/auth/lock/LockCentered';
import LockDefault from 'views/auth/lock/LockDefault';
import VerificationCentered from 'views/auth/verification/VerificationCentered';
import VerificationDefault from 'views/auth/verification/VerificationDefault';
import CocoRevSignIn from 'views/auth/signIn/CocoRevSignIn';
import CocoRevSignUp from 'views/auth/signUp/CocoRevSignUp';
import { Partners } from 'views/admin/main/ecosystem/partners/Partners';
import { HubSpotPortals } from 'views/admin/main/ecosystem/portals/HubSpotPortals';
import { Home } from 'views/admin/home/Home';
import { AICustomerGenerationPage } from 'views/admin/coselling/AICustomerGeneration';
import { Team } from 'views/admin/main/users/Users';
import { SnapshotsList } from 'views/admin/main/snapshots/SnapshotsList';
import { SnapshotCreate } from 'views/admin/main/snapshots/SnapshotCreate';
import { SnapshotDetailPage } from 'views/admin/main/snapshots/SnapshotDetail';
import { SnapshotJoin } from 'views/admin/main/snapshots/SnapshotJoin';

// Routes displayed in navigation sidebar
const navRoutes = [
  {
    name: 'Home',
    path: '/home',
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    layout: '/admin',
    component: <Home />,
  },
  {
    name: 'Team',
    path: '/team',
    icon: <Icon as={MdPeople} width="20px" height="20px" color="inherit" />,
    layout: '/admin',
    component: <Team />,
  },
  {
    name: 'Ecosystem',
    path: '/ecosystem',
    icon: <Icon as={MdDashboard} width="20px" height="20px" color="inherit" />,
    layout: '/admin',
    component: <Partners />,
  },
  {
    name: 'Ecosystem Signals',
    path: '/ecosystem-signals',
    icon: <Icon as={MdRadar} width="20px" height="20px" color="inherit" />,
    layout: '/admin',
    component: <AICustomerGenerationPage />,
  },
  {
    name: 'Snapshots',
    path: '/snapshots',
    navBadge: 'NEW',
    icon: <Icon as={MdAutoGraph} width="20px" height="20px" color="inherit" />,
    layout: '/admin',
    component: <SnapshotsList />,
  },
  {
    name: 'Settings',
    path: '/settings',
    icon: <Icon as={MdSettings} width="20px" height="20px" color="inherit" />,
    layout: '/admin',
    component: <HubSpotPortals />,
  },
];

// Hidden routes (functional but not shown in navigation)
const hiddenRoutes: RoutesType[] = [
  {
    name: 'Snapshot Join',
    path: '/snapshots/join/:token',
    layout: '/admin',
    component: <SnapshotJoin />,
  },
  {
    name: 'New Snapshot',
    path: '/snapshots/new',
    layout: '/admin',
    component: <SnapshotCreate />,
  },
  {
    name: 'Snapshot Detail',
    path: '/snapshots/:id',
    layout: '/admin',
    component: <SnapshotDetailPage />,
  },
];

// Authentication routes (not shown in navigation but still functional)
const authRoutes = [
  // --- Sign In ---
  {
    name: 'Sign In',
    layout: '/auth',
    path: '/sign-in',
    component: <CocoRevSignIn />,
  },
  // --- Sign Up ---
  {
    name: 'Sign Up',
    layout: '/auth',
    path: '/sign-up',
    component: <CocoRevSignUp />,
  },
  // --- Verification ---
  {
    name: 'Default Verification',
    layout: '/auth',
    path: '/verification/default',
    component: <VerificationDefault />,
  },
  {
    name: 'Centered Verification',
    layout: '/auth',
    path: '/verification/centered',
    component: <VerificationCentered />,
  },
  // --- Lock ---
  {
    name: 'Default Lock',
    layout: '/auth',
    path: '/lock/default',
    component: <LockDefault />,
  },
  {
    name: 'Centered Lock',
    layout: '/auth',
    path: '/lock/centered',
    component: <LockCentered />,
  },
  // --- Forgot Password ---
  {
    name: 'Forgot Password',
    layout: '/auth',
    path: '/forgot-password',
    component: <ForgotPasswordCentered />,
  },
  {
    name: 'Default Forgot Password',
    layout: '/auth',
    path: '/forgot-password/default',
    component: <ForgotPasswordDefault />,
  },
  {
    name: 'Centered Forgot Password',
    layout: '/auth',
    path: '/forgot-password/centered',
    component: <ForgotPasswordCentered />,
  },
];

// Export routes that should appear in navigation
export const routes = navRoutes;

// Export all routes (navigation, hidden, and auth) for use in router configuration
export const allRoutes = [...navRoutes, ...hiddenRoutes, ...authRoutes];

// Default export for backward compatibility
export default routes;
